import React, { useState } from 'react';
import { Card, Input, Button } from '../../components/ui';
import { AlertTriangle, TrendingUp, Users } from 'lucide-react';
import { cn } from '../../lib/utils';

export function RerouteToolComponent({ fallbackName, promptMsg }: { fallbackName: string; promptMsg?: string; }) {
  const [upvoted, setUpvoted] = useState(false);

  return (
    <Card className="p-8 text-center flex flex-col items-center bg-slate-100 border-slate-200 dark:bg-slate-800/40 dark:border-slate-700/50">
      <div className="w-16 h-16 bg-white dark:bg-slate-900/80 rounded-2xl border border-slate-200 dark:border-slate-700/50 flex items-center justify-center mb-6 shadow-inner">
        <AlertTriangle className="w-8 h-8 text-amber-500" />
      </div>
      
      <h3 className="text-2xl font-black mb-2 text-slate-900 dark:text-white font-display">
        {fallbackName}
      </h3>
      
      <p className="text-slate-500 dark:text-slate-400 text-sm max-w-md mb-8">
        {promptMsg || "This tool is currently in development. Our engineers are hard at work building out the next generation of calculators and builders."}
      </p>
      
      <div className="bg-white dark:bg-slate-900/60 p-6 rounded-xl border border-slate-200 dark:border-slate-700/50 w-full max-w-md">
         <h4 className="text-sm font-bold text-slate-800 dark:text-slate-300 mb-2">Want this tool faster?</h4>
         <p className="text-xs text-slate-500 mb-6">Let us know you need this, and we'll bump it up our priority queue.</p>
         
         <Button 
           className={cn("w-full gap-2 transition-all duration-300 text-white", upvoted ? "bg-green-600 hover:bg-green-600" : "bg-indigo-600 hover:bg-indigo-500")}
           onClick={() => setUpvoted(true)}
           disabled={upvoted}
         >
           {upvoted ? (
             <>Upvoted! We'll notify you.</>
           ) : (
             <>Upvote This Tool</>
           )}
         </Button>
      </div>
    </Card>
  );
}

